// stores/uploadStore.ts
import { create } from "zustand";
export const useUploadStore = create<{ pending: number; begin(): void; end(): void }>((set) => ({
  pending: 0,
  begin: () => set((s) => ({ pending: s.pending + 1 })),
  end: () => set((s) => ({ pending: Math.max(0, s.pending - 1) })),
}));
